import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import Controls from "../../../components/controls/Controls";
import Popup from "../../../components/customHelpers/Popup";
import AddProductForm from "../../../components/forms/addProduct";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";

const ProductDetails = ({ product, getProductData }) => {
  const { NotifyMessage, notify, setNotify } = Notify();

  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  const renderRow = (label, value) => (
    <ListItem
      sx={{
        backgroundColor: "background.paper",
        borderRadius: 1,
        "&:hover": { backgroundColor: "action.hover" },
        mb: 0.5,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <Typography
            variant="body2"
            fontWeight="bold"
            color="primary.main"
            noWrap
          >
            {label}
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography variant="body2" color="text.secondary">
            {value || "—"}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  );

  return (
    <>
      <List sx={{ p: 0 }}>
        {renderRow("Name", product?.name)}
        {renderRow("Type", product?.type)}
        {renderRow("Sku", product?.sku)}
        {renderRow("Bar Code", product?.bar_code)}
        {renderRow("Category", product?.category)}
        {renderRow("Description", product?.description)}

        <Box mt={1}>
          <Controls.Button
            text="Edit"
            size="small"
            variant="contained"
            sx={{ fontSize: "0.75rem" }}
            onClick={() => {
              setOpenPopup(true);
              setEdit(true);
            }}
          />
        </Box>
      </List>

      <Notification notify={notify} setNotify={setNotify} />

      <Popup
        title="Product Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddProductForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={product}
          getAllProducts={getProductData}
          openPopupUpdate
          edite={edite}
        />
      </Popup>
    </>
  );
};

export default ProductDetails;
